import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Table } from 'react-bootstrap';
import RichTextDisplay from '../../components/RichTextDisplay';
import { removeHTMLtagsAndDoubleQuotes } from '../../utils/StringUtils';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import VerbText from '../../components/VerbText';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';

const ShortEssayAnswers = (props) => {
    const { name, answer } = props;
    return (
        <p>
            {answer}
        </p>
    );
};

ShortEssayAnswers.propTypes = {
    name: PropTypes.string,
    answer: PropTypes.string,
};

class ShortEssayResultSlide extends Component {
    static propTypes = {
        name: PropTypes.string,
        content: PropTypes.shape({
            description: PropTypes.string,
            items: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string,
                    itemId: PropTypes.string
                })
            )
        }),
        canMoveToNext: PropTypes.func,
        canMoveToPrevious: PropTypes.func,
        onChange: PropTypes.func,
        nextSectionName: PropTypes.string,
        shortEssayQuestionData: PropTypes.object,
        shortEssayContent: PropTypes.array,
        currentUser: PropTypes.object,
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        hideBookmark: PropTypes.bool,
        sendWorkspaceSegementEvent: PropTypes.func,
        learningAssetType: PropTypes.func,
        currentUserTrack: PropTypes.object,
        isRefSheet: PropTypes.bool,
    };

    componentDidMount() {
        const { canMoveToPrevious, canMoveToNext, onChange } = this.props;

        if (canMoveToPrevious) canMoveToPrevious(true);
        if (canMoveToNext) canMoveToNext(true);

        const isCompleted = true;

        const isAnswered = true;
        if (onChange) onChange(null, isCompleted, isAnswered);
    }

    getUserAnswers = () => {
        const {
            shortEssayQuestionData,
            shortEssayContent = [],
            content: { items = [] },
            currentUser
        } = this.props;

        const contentData = shortEssayContent.reduce((acc, question) => {
            acc[question.id] = question;
            return acc;
        }, {});

        return items.map((item) => {
            const userAnswer = get(shortEssayQuestionData, `${item.itemId}.data.answer`, '');
            const answers = [];
            if (userAnswer) {
                answers.push(
                    <ShortEssayAnswers
                        key={`${item.itemId}-${currentUser._id}`}
                        name={currentUser.firstName}
                        answer={userAnswer}
                    />
                );
            }

            let answersSection = answers;
            if (answers.length <= 0) {
                answersSection = (
                    <VerbText messageId={'WORKSPACE_DNF'} defaultMessage={`You didn't answer this question.`} />
                );
            }

            return (
                <tr key={item.itemId} className={'shortEssayItemAnswer'}>
                    <td className='review-prev-activities-label-cell'>{removeHTMLtagsAndDoubleQuotes(get(contentData, `${item.itemId}.name`, ''))}</td>
                    <td>{answersSection}</td>
                </tr>
            );
        });
    };

    render() {
        const {
            currentUser,
            name,
            nextSectionName,
            content: { description = '' },
            sectionId,
            sectionItemId,
            hideBookmark,
            sendWorkspaceSegementEvent,
            learningAssetType,
            currentUserTrack,
            isRefSheet = false,
        } = this.props;
        let hideTableHeaders = false;
        if (currentUserTrack && currentUserTrack.track) {
            hideTableHeaders = currentUserTrack?.track?.hideQuestionAndResultsHeaders ?? false;
          }
        const answers = this.getUserAnswers();
        return (
            <div className={'shortEssaySlide'}>
                <div className={'playerContent'}>
                    <WorkspaceSlideHeader
                        headerText={name}
                        currentSectionItemId={sectionId}
                        currentSectionId={sectionItemId}
                        currentUser={currentUser}
                        hideBookmark={hideBookmark}
                        isRefSheet={isRefSheet}
                    />
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                    <Table striped={false} bordered={false} hover={false} className={'shortEssayItemAnswersList'}>
                        {!hideTableHeaders && (
                            <thead>
                                <tr>
                                    <th>
                                        <VerbText
                                            messageId={'WORKSPACE_ESSAY_RESPONSE_QUESTION'}
                                            defaultMessage={'Question'}
                                        />
                                    </th>
                                    <th>
                                        <VerbText
                                            messageId={'WORKSPACE_ESSAY_RESPONSE_RESPONSE'}
                                            defaultMessage={'Response'}
                                        />
                                    </th>
                                </tr>
                            </thead>
                        )}
                        <tbody>{answers}</tbody>
                    </Table>
                </div>
            </div>
        );
    }
}

export const ShortEssayResultSlideComponent = ShortEssayResultSlide;
export default TrackPlayerSlideComponent(ShortEssayResultSlide);
